<form [formGroup]="form">
	<div class="materials-form-wrapper">
		<div class="materials-form-item-wrapper heading">
			<div class="quantity">Qty</div>
			<div class="description">Description</div>
			<div class="amount">Amount</div>
			<div class="close-button"></div>
		</div>
		<ng-container *ngIf="form.controls.materials.controls.length === 0">
			<em class="text-center">No materials added</em>
		</ng-container>
		<ng-container *ngFor="let controlGroup of form.controls.materials.controls; let i = index">
			<div class="materials-form-item-wrapper">
				<app-standard-control
					class="quantity"
					[formGroup]="controlGroup"
					[smallPadding]="true"
					name="quantity"
					type="number"
					label="Qty"
					placeholder="Qty"
					labelPlacement="none"
				></app-standard-control>

				<app-standard-control
					class="description"
					[smallPadding]="true"
					[formGroup]="controlGroup"
					name="description"
					type="text"
					label="Description"
					placeholder="Description"
					labelPlacement="none"
					[dataListOptions]="inventoryItems"
				></app-standard-control>

				<app-standard-control
					class="amount"
					[smallPadding]="true"
					[formGroup]="controlGroup"
					name="amount"
					type="number"
					label="R"
					placeholder="R"
					labelPlacement="none"
				></app-standard-control>

				<div class="close-button">
					<button type="button" class="btn btn-sm btn-close" aria-label="Close" (click)="removeMaterialRow(i)"></button>
				</div>
			</div>
		</ng-container>

		<div class="button-wrapper">
			<button type="button" class="btn btn-sm btn-outline-primary" (click)="addMaterialRow()">
				<i class="bi bi-plus"></i>
				Add New
			</button>
		</div>
	</div>
</form>
